module.exports = __webpack_public_path__ + "static/media/home-data-backup.31606c07.svg";